import { ReactNode } from 'react';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocalStorage } from '@client/hooks/use-local-storage';
import { Alert } from '@design-system/components/alert/alert';
import { Typography } from '@design-system/components/typography/typography';
import { HELP_LINKS } from '@client/new/common/helpLinks';
import * as styles from './OffersMigrationAlert.css';

const TITLE = 'Your published One-time purchases are now parts of Offers';

type OffersMigrationAlertProps = {
  visible: boolean;
  dismissKey: string;
  body: ReactNode;
  learnMoreHref?: string;
  wrapperClassName?: string;
};

export const OffersMigrationAlert = ({
  visible,
  dismissKey,
  body,
  learnMoreHref = HELP_LINKS.otpOffersMigration,
  wrapperClassName,
}: OffersMigrationAlertProps) => {
  const [dismissed, setDismissed] = useLocalStorage(dismissKey, false);

  if (!visible || dismissed) return null;

  return (
    <Alert
      variant="info"
      alignStart
      allowClose
      closeLabel="Dismiss"
      onClose={() => setDismissed(true)}
      wrapperClassName={wrapperClassName}
      title={TITLE}
      customComponent={
        <div className={styles.bodyGroup}>
          {body}
          <a
            href={learnMoreHref}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.learnMore}
          >
            <Typography
              as="span"
              variant="body"
              size="medium"
              className={styles.learnMoreLabel}
            >
              Learn more
            </Typography>
            <FontAwesomeIcon
              icon={faArrowUpRightFromSquare}
              className={styles.learnMoreIcon}
            />
          </a>
        </div>
      }
    />
  );
};
